import { makeStyles } from '@soil-capital/ui-kit/style';

export default makeStyles()((theme) => ({
    confirm: { width: '100%' },
    cancel: { width: '100%' },
    typography: { paddingBottom: theme.spacing(2) },
}));
